import Checkbox from "components/_partials/Checkbox";
import { useFormik } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import { map, extend, omit } from "lodash";
import { useNavigate } from "react-router-dom";
import { useActivity } from "context/useActivity";
import { useMutation } from "react-query";
import { STORE_FEEDBACK } from "query/mutation";

const FeedbackForm = (props: { keywords: any }) => {
  const { keywords } = props;
  const [isFormSubmitted, setFormIsSubmitted] = useState<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(false);
  const { activityCtx } = useActivity();
  const navigate = useNavigate();

  const handleContinue = () => {
    if (activityCtx?.cycle_number === 4) {
      navigate("/thank-you");
    } else {
      navigate("/review-interests");
    }
  };

  const storeFeedback = useMutation(STORE_FEEDBACK, {
    onSuccess: () => {
      setFormIsSubmitted(true);
      handleContinue();
    },
    onError: (error) => {
      console.log("the error", error);
      setHasError(true);
    },
  });

  const feedbackForm = useFormik({
    initialValues: {
      q1: "",
      q2: "",
      q3: "",
      q4: "",
      q5: "",
      q6: "",
      q7: "",
      q8: "",
      interestedIn: [] as string[],
    },
    validationSchema: Yup.object({
      q1: Yup.string().required("Question 1 is required"),
      q2: Yup.string().required("Question 2 is required"),
      q3: Yup.string().required("Question 3 is required"),
      q4: Yup.string().required("Question 4 is required"),
      q5: Yup.string().required("Question 5 is required"),
      q6: Yup.string().required("Question 6 is required"),
      q7: Yup.string().required("Question 7 is required"),
    }),
    onSubmit: (values) => {
      const checkboxStates = map(keywords, (keyword: string) => {
        if (values.interestedIn.includes(keyword)) {
          return true;
        }
        return false;
      });
      const feedbackData = omit(
        extend(values, {
          checkboxStates: checkboxStates,
          novelty_score: activityCtx?.selectedActivity?.Novelty_Score,
          selected_order: activityCtx?.selectedActivity?.Recommendation_Order,
          q8: "",
          ...activityCtx,
        }),
        ["interestedIn", "selectedActivity"]
      );
      storeFeedback.mutate(feedbackData);
    },
  });

  const handleInterestCheckboxChange = (item: string) => {
    if (feedbackForm.values.interestedIn.includes(item)) {
      feedbackForm.setFieldValue(
        "interestedIn",
        feedbackForm.values.interestedIn.filter((i: string) => i !== item)
      );
    } else {
      feedbackForm.setFieldValue("interestedIn", [
        ...feedbackForm.values.interestedIn,
        item,
      ]);
    }
  };

  return (
    <>
      <div className="section-4 wf-section">
        <div className="container-5 w-container">
          <div className="w-form">
            <div>
              <label htmlFor="interestLevel">
                1. RATE your Interest level in this activity?{" "}
              </label>
              <select
                id="field"
                name="q1"
                data-name="Interest Level"
                value={feedbackForm.values.q1}
                onChange={feedbackForm.handleChange}
                className="w-select"
              >
                <option value="">Please provide your feedback </option>
                <option value="very interesting">Very interesting</option>
                <option value="a little interesting">
                  A little interesting
                </option>
                <option value="neutral, not interesting">
                  Neutral, not interesting
                </option>
                <option value="not at all interesting">
                  Not at all interesting
                </option>
              </select>
              {feedbackForm.errors.q1 && feedbackForm.touched.q1 && (
                <span className="error_text">{feedbackForm.errors.q1}</span>
              )}

              <label htmlFor="q2">
                2. DID YOU EXPECT TO BE RECOMMENDED AN ACTIVITY LIKE THIS?
              </label>
              <select
                id="q2"
                name="q2"
                data-name="q2"
                className="w-select"
                value={feedbackForm.values.q2}
                onChange={feedbackForm.handleChange}
              >
                <option value="">Please provide your feedback </option>
                <option value="very surprising">Very surprising</option>
                <option value="a little surprising">A little surprising</option>
                <option value="neutral, not surprising">
                  Neutral, not surprising
                </option>
                <option value="not at all surprising">
                  Not at all surprising
                </option>
              </select>
              {feedbackForm.errors.q2 && feedbackForm.touched.q2 && (
                <span className="error_text">{feedbackForm.errors.q2}</span>
              )}

              <label htmlFor="fun">
                3. How fun DO YOU EXPECT DOING THIS ACTIVITY WILL BE?{" "}
              </label>
              <select
                id="q3"
                name="q3"
                data-name="q3"
                value={feedbackForm.values.q3}
                onChange={feedbackForm.handleChange}
                className="w-select"
              >
                <option value="">Please provide your feedback </option>
                <option value="very fun">Very fun</option>
                <option value="a little fun">A little fun</option>
                <option value="neutral, not fun">Neutral, not fun</option>
                <option value="not at all fun">Not at all fun</option>
              </select>
              {feedbackForm.errors.q3 && feedbackForm.touched.q3 && (
                <span className="error_text">{feedbackForm.errors.q3}</span>
              )}

              <label htmlFor="q4">
                4. Would you have DISCOVERED this activity on your own?{" "}
              </label>
              <select
                id="q4"
                name="q4"
                data-name="On Your Own"
                value={feedbackForm.values.q4}
                onChange={feedbackForm.handleChange}
                className="w-select"
              >
                <option value="">Please provide your feedback </option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
                <option value="maybe">Maybe</option>
              </select>
              {feedbackForm.errors.q4 && feedbackForm.touched.q4 && (
                <span className="error_text">{feedbackForm.errors.q4}</span>
              )}

              <label htmlFor="q5">
                5. Do you think you would be q5 in careers related to this
                activity?  
              </label>
              <select
                id="q5"
                name="q5"
                data-name="q5"
                value={feedbackForm.values.q5}
                onChange={feedbackForm.handleChange}
                className="w-select"
              >
                <option value="">Please provide your feedback </option>
                <option value=" I’m very certain I could do careers like this activity">
                  {" "}
                  I’m very certain I could do careers like this activity
                </option>
                <option value="I’m a little certain I could do careers like this activity">
                  I’m a little certain I could do careers like this activity
                </option>
                <option value="neutral; I’m a little uncertain I could do careers like this activity">
                  Neutral; I’m a little uncertain I could do careers like this
                  activity
                </option>
                <option value="I could not do careers like this activity">
                  I could not do careers like this activity
                </option>
              </select>
              {feedbackForm.errors.q5 && feedbackForm.touched.q5 && (
                <span className="error_text">{feedbackForm.errors.q5}</span>
              )}

              <label htmlFor="q6">
                6. Does this activity make you more interested in exploring MORE
                ACTIVITIES LIKE THIS?
              </label>
              <select
                id="q6"
                name="q6"
                data-name="q6"
                value={feedbackForm.values.q6}
                onChange={feedbackForm.handleChange}
                className="w-select"
              >
                <option value="">Please provide your feedback </option>
                <option value="yes">Yes</option>
                <option value="not sure">Not sure</option>
                <option value="not really">Not really</option>
              </select>
              {feedbackForm.errors.q6 && feedbackForm.touched.q6 && (
                <span className="error_text">{feedbackForm.errors.q6}</span>
              )}

              <label htmlFor="q7">
                7. Do you know anyone that has a career related to this
                activity?
              </label>
              <select
                id="q7"
                name="q7"
                data-name="q7"
                value={feedbackForm.values.q7}
                onChange={feedbackForm.handleChange}
                className="w-select"
              >
                <option value="">Please provide your feedback </option>
                <option value="yes">Yes</option>
                <option value="not sure">Not sure</option>
                <option value="no">No</option>
              </select>
              {feedbackForm.errors.q7 && feedbackForm.touched.q7 && (
                <span className="error_text">{feedbackForm.errors.q7}</span>
              )}

              <div>
                <label htmlFor="email" className="field-label">
                  8. Which of the interests related to this activity we can add
                  to your profile?
                </label>
                {map(keywords || [], (thing) => (
                  <div key={thing}>
                    <Checkbox
                      name={thing}
                      value={feedbackForm.values.interestedIn.includes(thing)}
                      onChange={() => handleInterestCheckboxChange(thing)}
                      label={thing}
                    />
                  </div>
                ))}

                {feedbackForm.errors.interestedIn &&
                  feedbackForm.touched.interestedIn && (
                    <span className="error_text">
                      {feedbackForm.errors.interestedIn}
                    </span>
                  )}
              </div>
            </div>
            {isFormSubmitted && (
              <div className="w-form-done">
                <div>Thank you! Your submission has been received!</div>
              </div>
            )}
            {hasError && (
              <div className="w-form-fail">
                <div>Oops! Something went wrong while submitting the form.</div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="section-2 wf-section">
        {!isFormSubmitted && !hasError && (
          <>
            <div className="w-container">
              <div className="text-block-2">
                Please submit your responses before continuing the study.{" "}
              </div>
            </div>
            <div className="container-3 w-container">
              <button
                onClick={() => feedbackForm.handleSubmit()}
                id="w-node-a32db2df-47a3-79d3-bd46-e3ba7a24a9f4-25067e2d"
                className="button-2 w-button"
              >
                {storeFeedback.isLoading
                  ? "loading..."
                  : "SUBMIT YOUR RESPONSES"}
              </button>
            </div>
            s
          </>
        )}
        {isFormSubmitted && !hasError && (
          <div className="container-4 w-container">
            <button
              onClick={handleContinue}
              className="submit-button w-button"
              style={{
                pointerEvents: Boolean(isFormSubmitted && !hasError)
                  ? "auto"
                  : "none",
                cursor: Boolean(isFormSubmitted && !hasError)
                  ? "pointer"
                  : "not-allowed",
              }}
            >
              CONTINUE STUDY
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default FeedbackForm;
